export default function WhatsAppButton() {
  return (
    <a
      href="https://wa.link/em25v1"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-lg hover:scale-110 transition-all duration-300 animate-pulse-glow cursor-pointer"
      aria-label="Chat on WhatsApp"
    >
      <i className="ri-whatsapp-line text-2xl"></i>
    </a>
  );
}